import React from "react";
import Table from "../../components/subcomponents/table";
import TableControl from "../../components/subcomponents/table_control";
import Button from "../../components/subcomponents/controls/button";
import InputField from "../../components/subcomponents/controls/inputfield";
import CheckField from "../../components/subcomponents/controls/checkfield";
import { connect } from "react-redux";
import controller from "../../api/controller";
import notification from "../../components/subcomponents/notification";
import SubformDetails from "../../components/subcomponents/subform_details";
import FormHeader from "../../components/subcomponents/formheader";
import system from "./../../api/system";
import SelectField from "../../components/subcomponents/controls/selectfield";
import isPermitted from "../../permissions/permissions";

class controllerList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allow_to_edit: false,
      hide_details: true,
      selectedFile: null,
      inputFWKey: Date.now(),
    };
  }
  componentWillMount() {
    controller.list();
    controller.options();
    this.props.handleSelect(false);
    this.setState({ refresh_new_selected: this.props.controllers_state });
  }
  componentWillReceiveProps(nextProps) {
    //check if selected controller lost in state
    if (this.props.new_controller_selected) {
      if (nextProps.controllers_state !== this.state.refresh_new_selected) {
        let selected = this.props.new_controller_selected;
        let lost = true;
        Object.keys(nextProps.controllers_state).forEach(function (key) {
          if (selected === key) {
            lost = false;
          }
        });
        if (lost) {
          this.selectNewItem(false, false);
        }
      }
    }
  }
  selectItem(id, row) {
    let self = this;
    this.props.handleSelectNew(id, row);
    if (id) {
      this.setState({ hide_details: true });
      this.setState({ allow_to_edit: false });
      this.props.handleSelect(id);
      controller.details(function (error, response) {
        if (error) notification.error(error.message);
        self.setState({ hide_details: false });
      });
    } else {
      this.props.handleSelect(id);
      this.setState({ hide_details: true });
      this.setState({ allow_to_edit: false });
    }
  }
  selectNewItem(id, row) {
    this.props.handleSelect(false);
    if (id) {
      this.setState({ hide_details: false });
      this.setState({ allow_to_edit: false });
      this.props.handleSelectNew(id, row);
    } else {
      this.props.handleSelectNew(id);
      this.setState({ hide_details: true });
      this.setState({ allow_to_edit: true });
    }
  }
  handleSystemCommand(button_data) {
    system.remote_command(
      {
        type: "system",
        command: button_data.params.command,
        params: {
          controller_mac: button_data.params.controller_mac,
        },
      },
      function (err, res) {
        if (err) notification.error(err.api_error.message);
        else notification.success(res);
      }
    );
  }
  handleEdit() {
    this.props.history.push("/controller/update");
  }
  handleSave() {
    let self = this;
    if (this.props.controller_selected) {
      controller.update(function (error, response) {
        if (!error) {
          controller.list();
          self.setState({ hide_details: true });
        }
      });
    } else {
      controller.add(function (error, response) {
        if (!error) {
          controller.list();
          self.setState({ hide_details: true });
        }
      });
    }
  }
  handleDelete() {
    let self = this;
    controller.del(function (error, response) {
      if (!error) {
        notification.success("Record deleted");
      } else {
        notification.error(error.message);
      }
      controller.list();
      self.setState({ hide_details: true });
    });
  }
  confirmEdit(params) {
    this.setState({ allow_to_edit: params.value });
  }
  showDetails() {
    let save_btn_label = "";
    let details_title = "";
    let confirm_toggle_status = "hidden";
    if (this.props.controller_selected) {
      save_btn_label = "Update controller";
      details_title = "Selected controller details (on company change all subscribers will be deleted)";
      confirm_toggle_status = "";
    } else {
      details_title = "Enter new controller";
      save_btn_label = "Add new controller";
      confirm_toggle_status = "hidden";
    }

    let save_btn =
      this.props.controller_mac && this.props.controller_type
        ? "enabled"
        : "disabled";
    let del_btn = this.props.controller_selected ? "enabled" : "hidden";
    let inputs_enabled = "disabled";
    if (this.state.allow_to_edit || !this.props.controller_selected) {
      inputs_enabled = "enabled";
    } else {
      save_btn = "hidden";
      del_btn = "hidden";
    }
    return (
      <SubformDetails
        is_hidden={this.state.hide_details}
        title={details_title}
        className="details width_100"
      >
        <CheckField
          status={confirm_toggle_status}
          name="allow_to_edit"
          label="Enable edit"
          onChange={this.confirmEdit.bind(this)}
          value={this.state.allow_to_edit}
        />
        <InputField
          status={"disabled"}
          name="controller_mac"
          label="MAC (min. 4 chars)"
          onChange={this.props.fieldChange}
          value={this.props.controller_mac}
          error={this.props.controller_validation["controller_mac"]}
        />
        <InputField
          status={"disabled"}
          name="controller_type"
          label="Type (read only)"
          onChange={this.props.fieldChange}
          value={this.props.controller_type}
          error={this.props.controller_validation["controller_type"]}
        />
        <InputField
          status={inputs_enabled}
          name="controller_alias"
          label="Alias (uniq, min. 4 chars w/o spaces)"
          onChange={this.props.fieldChange}
          value={this.props.controller_alias}
          type="text"
          error={this.props.controller_validation["controller_alias"]}
        />
        <SelectField
          status={inputs_enabled}
          name="company_id"
          label="Company"
          options={this.props.controller_options["company_id"]}
          onChange={this.props.fieldChange}
          value={this.props.controller_company_id}
          error={this.props.controller_validation["company_id"]}
        />
        <div className="toolbar">
          <Button
            label={save_btn_label}
            name="add"
            onClick={this.handleSave.bind(this)}
            status={save_btn}
          />
          <Button
            label="Delete controller"
            name="delete"
            onClick={this.handleDelete.bind(this)}
            status={del_btn}
          />
        </div>
      </SubformDetails>
    );
  }
  render() {
    let device_table = [];
    let cont_state = this.props.controllers_online;
    let attached_controllers = this.props.controller_list;
    if (attached_controllers && attached_controllers.length > 0) {
      attached_controllers.map(function (result) {
        result.online = "OFF";
        result.channel = "";
        result.fw = "";

        return true;
      });
      if (cont_state) {
        cont_state.forEach(function (cont) {
          let row = {
            controller_mac: cont.mac,
            controller_type: cont.type,
            channel: cont.channel,
            fw: cont.fw,
          };
          let uniq = true;
          attached_controllers.map(function (result) {
            if (result.controller_mac === cont.mac) {
              uniq = false;
              result.online = "ON";
              result.channel = cont.channel;
              result.fw = cont.fw;
            }

            return true;
          });

          if (uniq) device_table.push(row);
        });
      }
    } else {
      if (cont_state) {
        cont_state.forEach(function (cont) {
          let row = {
            controller_mac: cont.mac,
            controller_type: cont.type,
            channel: cont.channel,
            fw: cont.fw,
          };
          device_table.push(row);
        });
      }
    }
    const filter = (isPermitted("Admin"))
    ? { options: this.props.controller_options["company_id"], value: this.props.controller_filter["company_id"] }
    : null
    return (
      <div className="form_wrap controller_list">
        <FormHeader title="CONTROLLER LIST" />
        <SubformDetails className="master width_100">
          <TableControl
            search={this.props.search_string}
            filter={filter}
            handleSearch={this.props.handleSearch}
            handleFilter={this.props.handleFilter}
          />
          <Table
            name="controller_list"
            selected={this.props.controller_selected}
            handleSelect={this.selectItem.bind(this)}
            table_key={"controller_id"}
            headers={{
              controller_id: { label: "CID", width: "10%" },
              company_name: { label: "Company", width: "25%" },
              controller_alias: { label: "ALIAS", width: "20%" },
              controller_mac: { label: "MAC", width: "15%" },
              controller_type: { label: "TYPE", width: "10%" },
              fw: { label: "VER", width: "10%" },
              online: { label: "ONLINE", width: "5%" },
              channel: { label: "CHANNEL", width: "5%" },
            }}
            data={this.props.controller_list}
          />
        </SubformDetails>
        {this.showDetails()}
        <SubformDetails
          className="details width_100"
          title="Available controllers"
        >
          <Table
            name="controllers_state"
            table_key={"controller_mac"}
            selected={this.props.new_controller_selected}
            handleSelect={this.selectNewItem.bind(this)}
            col_width={{
              controller_mac: "40%",
              controller_type: "30%",
              channel: "30%",
            }}
            headers={{
              controller_mac: { label: "MAC" },
              controller_type: { label: "TYPE" },
              fw: { label: "VER" },
              channel: { label: "CHANNEL" },
            }}
            data={device_table}
          />
        </SubformDetails>
      </div>
    );
  }
}

function mapStateToProps(state) {
  let controller = state.controllerR.controller;
  let new_controller = state.controllerR.new_controller;
  //firmware
  let fw_update = state.controllerR.fw_update;
  let fw_update_list = [];
  Object.keys(fw_update).map(function (mac) {
    fw_update_list.push({
      mac: mac,
      fsize: fw_update[mac].fsize,
      progress: Math.round((fw_update[mac].end / fw_update[mac].fsize) * 100),
    });

    return true;
  });
  //client cards
  let cards_sync = state.controllerR.cards_sync;
  let cards_sync_list = [];
  Object.keys(cards_sync).map(function (mac) {
    cards_sync_list.push({
      mac: mac,
      qty: cards_sync[mac].qty,
      progress: Math.round((cards_sync[mac].end / cards_sync[mac].qty) * 100),
    });

    return true;
  });
  return {
    search_string: controller.search_string,
    controller_list: controller.list,
    controller_selected: controller.selected,

    controller_id: controller.details.controller_id,
    controller_mac: controller.details.controller_mac,
    controller_type: controller.details.controller_type,
    controller_alias: controller.details.controller_alias,
    controller_company_id: controller.details.company_id,

    controller_validation: controller.validation,
    controller_filter: controller.filter,
    controller_options: controller.options,
    //all available controllers online
    controllers_online: state.systemR.controllers_online,

    new_controller_selected: new_controller.selected,
    fw_update_list: fw_update_list,
    cards_sync_list: cards_sync_list,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleSearch(result) {
      dispatch({
        type: "CONTROLLER_DESELECTED",
      });
      dispatch({
        type: "CONTROLLER_UPDATE_SEARCH_STRING",
        value: result.value,
      });
      controller.list();
    },
    handleFilter(result) {
        dispatch({
            type: "CONTROLLER_DESELECTED",
        });
        dispatch({
            type: "CONTROLLER_UPDATE_FILTER_STRING",
            value: result.value ? { [result.name]: result.value } : {},
        });
        controller.list();
    },
    handleSelect(id) {
      if (id) {
        dispatch({
          type: "CONTROLLER_SELECTED",
          value: id,
        });
      } else {
        dispatch({
          type: "CONTROLLER_DESELECTED",
        });
      }
    },
    handleSelectNew(id, row) {
      if (id && row) {
        dispatch({
          type: "NEW_CONTROLLER_SELECTED",
          value: id,
          details: row,
        });
      } else {
        dispatch({
          type: "NEW_CONTROLLER_DESELECTED",
        });
      }
    },
    fieldChange(result) {
      dispatch({
        type: "CONTROLLER_UPDATE_FORM",
        field: result.name,
        value: result.value,
      });
    },
  };
}

export default controllerList = connect(
  mapStateToProps,
  mapDispatchToProps
)(controllerList);
